module.exports = __webpack_public_path__ + "img/icon-state-up.cbfc649d.svg";